var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRing({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.4vw",
    height: "1.4vw",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#262626"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1087_2021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8122 11.4227L16.7815 9.42867L16.0297 7.90625H11.9707L11.2187 9.42867L13.1882 11.4227C11.1909 11.8087 9.67578 13.5866 9.67578 15.7182C9.67578 18.1312 11.6158 20.0938 14.0001 20.0938C16.3844 20.0938 18.3244 18.1312 18.3244 15.7182C18.3244 13.5866 16.8093 11.8085 14.8122 11.4227ZM14.2806 10.4809H13.7163L13.4214 9.5867H14.5754L14.2806 10.4809ZM15.7854 8.2995L16.227 9.19366H15.0145L14.8689 8.2995H15.7854ZM14.9895 9.5867H16.073L15.1894 10.4809H14.6948L14.9895 9.5867ZM13.5293 8.2995H14.4705L14.6162 9.19366H13.3812L13.5293 8.2995ZM12.2148 8.2995H13.1309L12.9829 9.19366H11.7733L12.2148 8.2995ZM11.9266 9.5867H13.0074L13.3022 10.4809H12.8072L11.9266 9.5867ZM14.0001 19.7005C11.8324 19.7005 10.0688 17.914 10.0688 15.7182C10.0688 13.5225 11.8326 11.7358 14.0001 11.7358C16.1677 11.7358 17.9312 13.5223 17.9312 15.7182C17.9312 17.9142 16.1679 19.7005 14.0001 19.7005Z",
    fill: "#E77B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9996 12.1938C12.0787 12.1938 10.5156 13.775 10.5156 15.7183C10.5156 17.6618 12.0787 19.2429 13.9996 19.2429C15.9206 19.2429 17.4836 17.662 17.4836 15.7183C17.4836 13.775 15.9206 12.1938 13.9996 12.1938ZM13.9996 18.8496C12.2952 18.8496 10.9087 17.4448 10.9087 15.7183C10.9087 13.9917 12.2954 12.5869 13.9996 12.5869C15.7038 12.5869 17.0904 13.9917 17.0904 15.7183C17.0904 17.4448 15.704 18.8496 13.9996 18.8496Z",
    fill: "#E77B7B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1087_2021"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(7.5 7.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing);
export default __webpack_public_path__ + "static/media/ring.483b70b2673700516d6501397279ca03.svg";
export { ForwardRef as ReactComponent };